import React, { useEffect } from 'react';
import { Stepper } from '@shared/components/Stepper';
import { SelectBillsStep } from './stepComponents/SelectBillsStep';
import { PaymentDetailsStep } from './stepComponents/PaymentDetailsStep';
import { ReviewPayStep } from './stepComponents/ReviewPayStep';
import { ConfirmationStep } from './stepComponents/ConfirmationStep';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageHeader } from '@shared/components/PageHeader';
import { useTranslation } from 'react-i18next';

export const PayBill = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      localStorage.removeItem('pay-bill-draft');
    };
  }, []);

  const steps = [
    {
      title: t("Select Bills"),
      slug: "select-bills",
      component: <SelectBillsStep />,
      optional: false,
    },
    {
      title: t("Payment Details"),
      slug: "payment-details",
      component: <PaymentDetailsStep />,
      optional: false,
    },
    {
      title: t("Review & Pay"),
      slug: "review-pay",
      component: <ReviewPayStep />,
      optional: false,
    },
    {
      title: t("Confirmation"),
      slug: "confirmation",
      component: <ConfirmationStep />,
      optional: false,
    },
  ];

  return (
    <div className="p-6 space-y-6 max-w-7xl mx-auto">

      <PageHeader 
        title={t("Pay Bill")} 
        subtitle={t("Follow the steps below to complete your bill payment")}
        icon={ArrowLeft}
        onIconClick={() => navigate('/dashboard/billing')}
      />
      
      <div className="mt-8">
        <Stepper
          steps={steps}
          onStepChange={() => {}}
          onValidation={async () => ({ isValid: true })}
          onComplete={() => {}}
          storageKey="pay-bill-draft"
          enableApiSave={false}
          saveOnStepChange={true}
          trackDirtyState={true}
          autoSave={true}
          persistProgress={true}
          allowSkip={false}
          showDraftResume={false}
          contentClassName="bg-transparent border-0 mt-4"
        />
      </div>
    </div>
  );
};
